module.exports = __webpack_public_path__ + "img/logo-footer-05.d799fde5.jpg";